/**
 * Environments in which PostHog actually captures events. Other environments
 * (notably `local` and `development`) initialise the adapter for shape parity
 * but no-op on capture — PostHog is metered and we don't want local-dev
 * events counted against the plan.
 *
 * Kept in its own file (separate from `posthog-adapter.ts`) so consumers like
 * the pre-mount error-fallback in `router.tsx` can import the env list
 * WITHOUT pulling `posthog-js` into the main bundle. Importing from the
 * adapter directly would force posthog-js into the eagerly-loaded chunk and
 * defeat the lazy-load split.
 */
export const POSTHOG_CAPTURE_ENVIRONMENTS = new Set([
  'qa',
  'staging',
  'production',
]);
